import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
    server: {
      apiKey: "FDQQtQTJebodt88s1Zi9zhb4RQEunzft",
      nodes: [
        {
          host: "jm465nzda83iykoep-1.a1.typesense.net",
          port: "443",
          path: "",
          protocol: "https",
        },
      ],
      cacheSearchResultsForSeconds: 2 * 60,
    },
    additionalSearchParameters: {
      query_by: "name,account_name,account_short_description,all_tags",
      sort_by: "available:desc,created_at:desc",
    },
});

const searchClient = typesenseInstantsearchAdapter.searchClient;

export default searchClient

// import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

// const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
//     server: {
//       apiKey: "15ASgIbUG7oEChzj5PC06JzTReL0hyiM",
//       nodes: [
//         {
//           host: "v2cox7b0amnqzrtep-1.a1.typesense.net",
//           port: "443",
//           path: "",
//           protocol: "https",
//         },
//       ],
//       cacheSearchResultsForSeconds: 2 * 60,
//     },
//     additionalSearchParameters: {
//       query_by: "name",
//     },
// });

// const searchClient = typesenseInstantsearchAdapter.searchClient;

// export default searchClient
